export default "__VITE_ASSET__GYBBREUK__"